import { getUnreadThreadCountFromDynamoDB } from "./getUnreadThreadCountFromDynamoDB"
import { getUnreadThreadCountFromOpenSearch } from "./getUnreadThreadCountFromOpenSearch"
import { getCachedFeatureFlags } from "src/apis/common/getFeatureFlags"

type Params = {
  accessToken: string
  accountId: string
  contactIds?: string[]
}

/**
 * 未読カウントを取得
 * FeatureFlagに応じてDynamoDB GSIまたはOpenSearchを使用
 */
export const getUnreadThreadCount = async ({
  accessToken,
  accountId,
  contactIds,
}: Params): Promise<any> => {
  if (contactIds != null && contactIds.length === 0) {
    return { buckets: [] }
  }

  const featureFlags = getCachedFeatureFlags()
  const useDynamoDB = featureFlags.useUnreadCountDynamoDBGSI

  console.log(`[UnreadCount] Using ${useDynamoDB ? 'DynamoDB GSI' : 'OpenSearch'}`)

  if (useDynamoDB) {
    try {
      return await getUnreadThreadCountFromDynamoDB({
        accessToken,
        accountId,
        contactIds
      })
    } catch (error) {
      console.error('[UnreadCount] DynamoDB failed, falling back to OpenSearch:', error)
      return await getUnreadThreadCountFromOpenSearch({
        accessToken,
        accountId,
        contactIds
      })
    }
  }

  return await getUnreadThreadCountFromOpenSearch({
    accessToken,
    accountId,
    contactIds
  })
}
